var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "#6C737F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9125 14.5C6.9125 13.0037 8.12875 11.7875 9.625 11.7875H13.125V10.125H9.625C7.21 10.125 5.25 12.085 5.25 14.5C5.25 16.915 7.21 18.875 9.625 18.875H13.125V17.2125H9.625C8.12875 17.2125 6.9125 15.9963 6.9125 14.5ZM10.5 15.375H17.5V13.625H10.5V15.375ZM18.375 10.125H14.875V11.7875H18.375C19.8713 11.7875 21.0875 13.0037 21.0875 14.5C21.0875 15.9963 19.8713 17.2125 18.375 17.2125H14.875V18.875H18.375C20.79 18.875 22.75 16.915 22.75 14.5C22.75 12.085 20.79 10.125 18.375 10.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.14c686f451f0994bc48dc6ddad926946.svg";
export { ForwardRef as ReactComponent };